import { defineTranslateKeys } from 'lib/tolgee'

export const translations = defineTranslateKeys({
  uploadingText: (currentFile: number, totalFiles: number) => ({
    key: 'upload-loading-uploadingText',
    parameters: { currentFile, totalFiles },
    defaultValue: 'Carregando {currentFile} de {totalFiles} {totalFiles, plural, one {arquivo} other {arquivos}}',
  }),
})
